export const getSrc = (img) => {
    if (!img) return null

    const res = ((img?.height || img?.width) ? ('?') : '') +
        ((img?.height) ? ('h=' + img.height) : '') +
        ((img.height && img.width) ? ('&') : '') +
        ((img.width) ? ('w=' + img.width) : '')

    if (img?.source && img?.height && img?.width) {
        var source = img.source.replace(/ /g, "%20")
        let img_paths = source.split('.')
        let img_ext = img_paths.pop()
        source = img_paths.join('.') + '-size-' + img.width + 'x' + img.height + '.' + img_ext;
    }

    return source ? source + res : img?.source
}